import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-rat-button',
  templateUrl: './rat-button.component.html',
  styleUrls: ['./rat-button.component.css']
})
export class RatButtonComponent implements OnInit {
  @Input() question!: any;
  @Input() eachControl!: any;
  @Input() controlIndex!: number;
  constructor() { }

  ngOnInit(): void {
  }

}
